import { render, staticRenderFns } from "./chain.vue?vue&type=template&id=4eeeb4f6&scoped=true&"
import script from "./chain.vue?vue&type=script&lang=js&"
export * from "./chain.vue?vue&type=script&lang=js&"
import style0 from "./chain.vue?vue&type=style&index=0&id=4eeeb4f6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eeeb4f6",
  null
  
)

export default component.exports